// Import our custom CSS
import '../scss/styles.scss';
import 'intl-tel-input/build/css/intlTelInput.css';
import intlTelInput from 'intl-tel-input';
import * as bootstrap from 'bootstrap';
// Import only the Bootstrap components we need
import { Util, Dropdown, Offcanvas, Popover,Alert } from 'bootstrap';
if (process.env.NODE_ENV !== 'production') {
  console.log('Looks like we are in development mode!');
}


(() => {
  'use strict'

  // Fetch all the forms we want to apply custom Bootstrap validation styles to
  const forms = document.querySelectorAll('.needs-validation')

  // Loop over them and prevent submission
  Array.from(forms).forEach(form => {
    form.addEventListener('submit', event => {
      if (!form.checkValidity()) {
        event.preventDefault()
        event.stopPropagation()
      }
      form.classList.add('was-validated')
    }, false)
  })
})()


  // const input = document.querySelector("#floatingInputPhone");
  // if (input) {
  //   var iti = intlTelInput(input, {
  //     initialCountry: "se",
  //     geoIpLookup: function (callback) {
  //       $.get('https://ipinfo.io', function () { }, "jsonp").always(function (resp) {
  //         var countryCode = (resp && resp.country) ? resp.country : "se";
  //         callback(countryCode);
  //       });
  //     },
  //     utilsScript: "./utils.js?1638200991544" // just for formatting/placeholders etc
  //   });
   
  // var errorMsgPhoneNumber = document.querySelector("#phoneNumberMsg");
  //   var reset = function () {
  //     errorMsgPhoneNumber.classList.add("hide");
  //   };
  //   // on blur: validate
  //   input.addEventListener('blur', function () {
  //     reset();
  //     if (input.value.trim()) {
  //       if (iti.isValidNumber()) {
  //         //validMsg.classList.remove("hide");
  //       } else {
  //         input.classList.add("is-invalid");
  //         input.classList.add("error");
  //         var errorCode = iti.getValidationError();
  //         console.log(errorCode);
  //         // errorMsg.innerHTML = errorMap[errorCode];
  //         errorMsgPhoneNumber.classList.remove("hide");
  //       }
  //     }
  //   });
  //   // on keyup / change flag: reset
  //   input.addEventListener('change', reset);
  //   input.addEventListener('keyup', reset);
  // }